import { CharacterCreationController } from '@/game/GameComponents/PhaserGame/Scenes/CharacterCreation/CharacterCreationController';
import DefaultConfirmButton_m from '@/game/prefabs/DefaultConfirmButton_m';
import DefaultButton from '@/game/prefabs/GeneralUI/Buttons/DefaultButton';
import ComplexionSelection from '@/game/prefabs/GeneralUI/ComplexionSelection';
import LoadingSpinner from '@/game/prefabs/GeneralUI/LoadingSpinner';
import PlayerDoll from '@/game/prefabs/GeneralUI/PlayerDoll';

/* START OF COMPILED CODE */

export default class CharacterCreation extends Phaser.Scene {

	constructor() {
		super("CharacterCreation");

		/* START-USER-CTR-CODE */

    this._controller = new CharacterCreationController(this);

    /* END-USER-CTR-CODE */
	}

	preload(): void {

		this.load.pack("default-character-spritesheets", "game_assets/sprites/phaser_game/character_sprites/sprite_assets/default-character-spritesheets.json");
	}

	editorCreate(): void {

		// creationBackground
		const creationBackground = this.add.image(519, 376, "forest-background");
		creationBackground.scaleX = 5;
		creationBackground.scaleY = 5;

		// desktopView
		const desktopView = this.add.container(0, 0);
		desktopView.visible = false;

		// mainContainer
		const mainContainer = this.add.container(512, 384);
		desktopView.add(mainContainer);

		// mainBacking
		const mainBacking = this.add.nineslice(0, 0, "Hud1", undefined, 224, 168, 8, 8, 8, 8);
		mainBacking.scaleX = 4;
		mainBacking.scaleY = 4;
		mainContainer.add(mainBacking);

		// submitButton
		const submitButton = new DefaultButton(this, 0, 280);
		mainContainer.add(submitButton);

		// image_1
		const image_1 = this.add.image(0, 0, "1x1sprite");
		image_1.scaleX = 888;
		image_1.scaleY = 444;
		image_1.alpha = 0.05;
		image_1.alphaTopLeft = 0.05;
		image_1.alphaTopRight = 0.05;
		image_1.alphaBottomLeft = 0.05;
		image_1.alphaBottomRight = 0.05;
		image_1.tintTopLeft = 0;
		image_1.tintTopRight = 0;
		image_1.tintBottomLeft = 0;
		image_1.tintBottomRight = 0;
		mainContainer.add(image_1);

		// playerContainer
		const playerContainer = this.add.container(-328, 0);
		mainContainer.add(playerContainer);

		// playerBacking
		const playerBacking = this.add.nineslice(0, 0, "panel segment", undefined, 40, 64, 4, 4, 4, 4);
		playerBacking.scaleX = 4;
		playerBacking.scaleY = 4;
		playerContainer.add(playerBacking);

		// image
		const image = this.add.image(0, 0, "zone-snippet");
		playerContainer.add(image);

		// playerDoll
		const playerDoll = new PlayerDoll(this, 0, 0);
		playerContainer.add(playerDoll);

		// complexionSelection
		const complexionSelection = new ComplexionSelection(this, -390, 154);
		mainContainer.add(complexionSelection);

		// itemScrollGroupContainer
		const itemScrollGroupContainer = this.add.container(-216, -224);
		mainContainer.add(itemScrollGroupContainer);

		// gridBacking
		const gridBacking = this.add.nineslice(0, 0, "panel segment", undefined, 152, 112, 4, 4, 4, 8);
		gridBacking.scaleX = 4;
		gridBacking.scaleY = 4;
		gridBacking.setOrigin(0, 0);
		itemScrollGroupContainer.add(gridBacking);

		// gridScrollBar
		const gridScrollBar = this.add.container(616, 0);
		itemScrollGroupContainer.add(gridScrollBar);

		// scrollBarBacking
		const scrollBarBacking = this.add.nineslice(0, 0, "panel segment", undefined, 8, 112, 4, 4, 8, 8);
		scrollBarBacking.scaleX = 4;
		scrollBarBacking.scaleY = 4;
		scrollBarBacking.setOrigin(0.5, 0);
		gridScrollBar.add(scrollBarBacking);

		// scrollBarHandle
		const scrollBarHandle = this.add.image(0, 0, "scrollbar-handle");
		scrollBarHandle.scaleX = 4;
		scrollBarHandle.scaleY = 4;
		scrollBarHandle.setOrigin(0.5, 0);
		gridScrollBar.add(scrollBarHandle);

		// content
		const content = this.add.container(0, 0);
		itemScrollGroupContainer.add(content);

		// loadingContainer
		const loadingContainer = this.add.container(0, 0);
		itemScrollGroupContainer.add(loadingContainer);

		// spinnerBlocker
		const spinnerBlocker = this.add.image(0, 0, "1x1sprite");
		spinnerBlocker.scaleX = 632;
		spinnerBlocker.scaleY = 448;
		spinnerBlocker.setOrigin(0, 0);
		spinnerBlocker.alpha = 0.3;
		spinnerBlocker.alphaTopLeft = 0.31;
		spinnerBlocker.alphaTopRight = 0.3;
		spinnerBlocker.alphaBottomLeft = 0.3;
		spinnerBlocker.alphaBottomRight = 0.3;
		spinnerBlocker.tintTopLeft = 985612;
		spinnerBlocker.tintTopRight = 985612;
		spinnerBlocker.tintBottomLeft = 985612;
		spinnerBlocker.tintBottomRight = 985612;
		loadingContainer.add(spinnerBlocker);

		// loadingSpinner
		const loadingSpinner = new LoadingSpinner(this, 316, 224);
		loadingContainer.add(loadingSpinner);

		// gridHeader
		const gridHeader = this.add.container(0, -224);
		mainContainer.add(gridHeader);

		// nineslice_2
		const nineslice_2 = this.add.nineslice(0, 0, "Hud2", undefined, 48, 12, 4, 4, 4, 4);
		nineslice_2.scaleX = 4;
		nineslice_2.scaleY = 4;
		gridHeader.add(nineslice_2);

		// bitmaptext_2
		const bitmaptext_2 = this.add.bitmapText(0, 0, "Aronui", "Select Your Outfit");
		bitmaptext_2.setOrigin(0.5, 0.5);
		bitmaptext_2.tintTopLeft = 5387071;
		bitmaptext_2.tintTopRight = 5387071;
		bitmaptext_2.tintBottomLeft = 5387071;
		bitmaptext_2.tintBottomRight = 5387071;
		bitmaptext_2.text = "Select Your Outfit";
		bitmaptext_2.fontSize = -16;
		gridHeader.add(bitmaptext_2);

		// titleContainer
		const titleContainer = this.add.container(0, -320);
		mainContainer.add(titleContainer);

		// titleBacking
		const titleBacking = this.add.nineslice(0, 0, "Hud2", undefined, 96, 18, 4, 4, 4, 8);
		titleBacking.scaleX = 4;
		titleBacking.scaleY = 4;
		titleContainer.add(titleBacking);

		// bitmaptext_1
		const bitmaptext_1 = this.add.bitmapText(0, 0, "Aronui", "Character Creation\n");
		bitmaptext_1.setOrigin(0.5, 0.5);
		bitmaptext_1.tintTopLeft = 985612;
		bitmaptext_1.tintTopRight = 985612;
		bitmaptext_1.tintBottomLeft = 985612;
		bitmaptext_1.tintBottomRight = 985612;
		bitmaptext_1.text = "Character Creation\n";
		bitmaptext_1.fontSize = -30;
		titleContainer.add(bitmaptext_1);

		// mobileView
		const mobileView = this.add.container(0, 0);

		// mainContainer_m
		const mainContainer_m = this.add.container(339, 188);
		mobileView.add(mainContainer_m);

		// mainBacking_m
		const mainBacking_m = this.add.nineslice(0, 0, "Hud1", undefined, 302, 156, 8, 8, 8, 8);
		mainBacking_m.scaleX = 2;
		mainBacking_m.scaleY = 2;
		mainContainer_m.add(mainBacking_m);

		// submitButton_m
		const submitButton_m = new DefaultConfirmButton_m(this, -3, 116);
		mainContainer_m.add(submitButton_m);

		// image_1_m
		const image_1_m = this.add.image(0, 0, "1x1sprite");
		image_1_m.scaleX = 888;
		image_1_m.scaleY = 444;
		image_1_m.alpha = 0.05;
		image_1_m.alphaTopLeft = 0.05;
		image_1_m.alphaTopRight = 0.05;
		image_1_m.alphaBottomLeft = 0.05;
		image_1_m.alphaBottomRight = 0.05;
		image_1_m.tintTopLeft = 0;
		image_1_m.tintTopRight = 0;
		image_1_m.tintBottomLeft = 0;
		image_1_m.tintBottomRight = 0;
		mainContainer_m.add(image_1_m);

		// playerContainer_m
		const playerContainer_m = this.add.container(-203, -8);
		mainContainer_m.add(playerContainer_m);

		// playerBacking_m
		const playerBacking_m = this.add.nineslice(0, 0, "panel segment", undefined, 80, 128, 4, 4, 4, 4);
		playerBacking_m.scaleX = 2;
		playerBacking_m.scaleY = 2;
		playerContainer_m.add(playerBacking_m);

		// image_m
		const image_m = this.add.image(0, 0, "zone-snippet");
		playerContainer_m.add(image_m);

		// playerDoll_m
		const playerDoll_m = new PlayerDoll(this, 0, 0);
		playerContainer_m.add(playerDoll_m);

		// complexionSelection_m
		const complexionSelection_m = new ComplexionSelection(this, -263, 108);
		mainContainer_m.add(complexionSelection_m);

		// itemScrollGroupContainer_m
		const itemScrollGroupContainer_m = this.add.container(-111, -120);
		mainContainer_m.add(itemScrollGroupContainer_m);

		// gridBacking_m
		const gridBacking_m = this.add.nineslice(0, 0, "panel segment", undefined, 196, 102, 4, 4, 4, 8);
		gridBacking_m.scaleX = 2;
		gridBacking_m.scaleY = 2;
		gridBacking_m.setOrigin(0, 0);
		itemScrollGroupContainer_m.add(gridBacking_m);

		// gridScrollBar_m
		const gridScrollBar_m = this.add.container(384, 0);
		itemScrollGroupContainer_m.add(gridScrollBar_m);

		// scrollBarBacking_m
		const scrollBarBacking_m = this.add.nineslice(0, 0, "panel segment", undefined, 8, 102, 4, 4, 8, 8);
		scrollBarBacking_m.scaleX = 2;
		scrollBarBacking_m.scaleY = 2;
		scrollBarBacking_m.setOrigin(0.5, 0);
		gridScrollBar_m.add(scrollBarBacking_m);

		// scrollBarHandle_m
		const scrollBarHandle_m = this.add.image(0, 0, "scrollbar-handle");
		scrollBarHandle_m.scaleX = 2;
		scrollBarHandle_m.scaleY = 2;
		scrollBarHandle_m.setOrigin(0.5, 0);
		gridScrollBar_m.add(scrollBarHandle_m);

		// content_m
		const content_m = this.add.container(0, 0);
		itemScrollGroupContainer_m.add(content_m);

		// loadingContainer_m
		const loadingContainer_m = this.add.container(0, 0);
		itemScrollGroupContainer_m.add(loadingContainer_m);

		// spinnerBlocker_m
		const spinnerBlocker_m = this.add.image(0, 0, "1x1sprite");
		spinnerBlocker_m.scaleX = 392;
		spinnerBlocker_m.scaleY = 204;
		spinnerBlocker_m.setOrigin(0, 0);
		spinnerBlocker_m.alpha = 0.3;
		spinnerBlocker_m.alphaTopLeft = 0.31;
		spinnerBlocker_m.alphaTopRight = 0.3;
		spinnerBlocker_m.alphaBottomLeft = 0.3;
		spinnerBlocker_m.alphaBottomRight = 0.3;
		spinnerBlocker_m.tintTopLeft = 985612;
		spinnerBlocker_m.tintTopRight = 985612;
		spinnerBlocker_m.tintBottomLeft = 985612;
		spinnerBlocker_m.tintBottomRight = 985612;
		loadingContainer_m.add(spinnerBlocker_m);

		// loadingSpinner_m
		const loadingSpinner_m = new LoadingSpinner(this, 196, 102);
		loadingContainer_m.add(loadingSpinner_m);

		// gridHeader_m
		const gridHeader_m = this.add.container(-19, -104);
		mainContainer_m.add(gridHeader_m);

		// nineslice_2_m
		const nineslice_2_m = this.add.nineslice(0, 0, "Hud2", undefined, 96, 20, 4, 4, 4, 4);
		nineslice_2_m.scaleX = 2;
		nineslice_2_m.scaleY = 2;
		gridHeader_m.add(nineslice_2_m);

		// bitmaptext_2_m
		const bitmaptext_2_m = this.add.bitmapText(0, 0, "Aronui", "Select Your Outfit");
		bitmaptext_2_m.setOrigin(0.5, 0.5);
		bitmaptext_2_m.tintTopLeft = 5387071;
		bitmaptext_2_m.tintTopRight = 5387071;
		bitmaptext_2_m.tintBottomLeft = 5387071;
		bitmaptext_2_m.tintBottomRight = 5387071;
		bitmaptext_2_m.text = "Select Your Outfit";
		bitmaptext_2_m.fontSize = -16;
		gridHeader_m.add(bitmaptext_2_m);

		// titleContainer_m
		const titleContainer_m = this.add.container(-3, -152);
		mainContainer_m.add(titleContainer_m);

		// titleBacking_m
		const titleBacking_m = this.add.nineslice(0, 0, "Hud2", undefined, 140, 20, 4, 4, 4, 8);
		titleBacking_m.scaleX = 2;
		titleBacking_m.scaleY = 2;
		titleContainer_m.add(titleBacking_m);

		// bitmaptext_1_m
		const bitmaptext_1_m = this.add.bitmapText(0, 0, "Aronui", "Character Creation\n");
		bitmaptext_1_m.setOrigin(0.5, 0.5);
		bitmaptext_1_m.tintTopLeft = 985612;
		bitmaptext_1_m.tintTopRight = 985612;
		bitmaptext_1_m.tintBottomLeft = 985612;
		bitmaptext_1_m.tintBottomRight = 985612;
		bitmaptext_1_m.text = "Character Creation\n";
		bitmaptext_1_m.fontSize = -24;
		titleContainer_m.add(bitmaptext_1_m);

		// submitButton (prefab fields)
		submitButton.buttonText = "Start";

		// submitButton_m (prefab fields)
		submitButton_m.buttonText = "Start";

		this.creationBackground = creationBackground;
		this.submitButton = submitButton;
		this.complexionSelection = complexionSelection;
		this.gridBacking = gridBacking;
		this.scrollBarBacking = scrollBarBacking;
		this.scrollBarHandle = scrollBarHandle;
		this.content = content;
		this.spinnerBlocker = spinnerBlocker;
		this.loadingSpinner = loadingSpinner;
		this.loadingContainer = loadingContainer;
		this.mainContainer = mainContainer;
		this.desktopView = desktopView;
		this.submitButton_m = submitButton_m;
		this.complexionSelection_m = complexionSelection_m;
		this.gridBacking_m = gridBacking_m;
		this.scrollBarBacking_m = scrollBarBacking_m;
		this.scrollBarHandle_m = scrollBarHandle_m;
		this.content_m = content_m;
		this.spinnerBlocker_m = spinnerBlocker_m;
		this.loadingSpinner_m = loadingSpinner_m;
		this.loadingContainer_m = loadingContainer_m;
		this.mainContainer_m = mainContainer_m;
		this.mobileView = mobileView;

		this.events.emit("scene-awake");
	}

	public creationBackground!: Phaser.GameObjects.Image;
	public submitButton!: DefaultButton;
	public complexionSelection!: ComplexionSelection;
	public gridBacking!: Phaser.GameObjects.NineSlice;
	public scrollBarBacking!: Phaser.GameObjects.NineSlice;
	public scrollBarHandle!: Phaser.GameObjects.Image;
	public content!: Phaser.GameObjects.Container;
	public spinnerBlocker!: Phaser.GameObjects.Image;
	public loadingSpinner!: LoadingSpinner;
	public loadingContainer!: Phaser.GameObjects.Container;
	public mainContainer!: Phaser.GameObjects.Container;
	public desktopView!: Phaser.GameObjects.Container;
	public submitButton_m!: DefaultConfirmButton_m;
	public complexionSelection_m!: ComplexionSelection;
	public gridBacking_m!: Phaser.GameObjects.NineSlice;
	public scrollBarBacking_m!: Phaser.GameObjects.NineSlice;
	public scrollBarHandle_m!: Phaser.GameObjects.Image;
	public content_m!: Phaser.GameObjects.Container;
	public spinnerBlocker_m!: Phaser.GameObjects.Image;
	public loadingSpinner_m!: LoadingSpinner;
	public loadingContainer_m!: Phaser.GameObjects.Container;
	public mainContainer_m!: Phaser.GameObjects.Container;
	public mobileView!: Phaser.GameObjects.Container;

	/* START-USER-CODE */

  private _controller: CharacterCreationController;
  get controller() {
    return this._controller;
  }

  create() {
    this.editorCreate();
    this.controller.create();
  }

  init(data: any) {
    this.controller.init(data);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
